import React from 'react';

export function DimensionComponent(props: { value: readonly number[] }) {
  if (props.value.length === 1) {
    return <>{props.value[0]}</>;
  }

  return <>{props.value.join('/')}</>;
}
